"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleDataCheckComponent = void 0;
const core_1 = require("@angular/core");
require("./data-check.component.scss");
let VehicleDataCheckComponent = class VehicleDataCheckComponent {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleDataCheckComponent.prototype, "vehicle", void 0);
VehicleDataCheckComponent = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-data-check',
        template: `
    <ab-card
      *ngIf="vehicle.dataCheck"
      [classes]="'filled success'"
      [titleUser]="vehicle.dataCheck?.user + ''"
      [subtitle]="vehicle.dataCheck.date | date: 'dd.MM.yyyy HH:mm'"
      [displayIcon]="'shield-check'"
      [displayText]="'Datencheck'"
    ></ab-card>

    <ab-card
      *ngIf="!vehicle.dataCheck"
      [classes]="'filled warning'"
      [title]="'Kein Datencheck'"
      [titleIcon]="'shield-exclamation'"
    ></ab-card>
  `,
    })
], VehicleDataCheckComponent);
exports.VehicleDataCheckComponent = VehicleDataCheckComponent;
